import {
  billingStatusValues,
  planCodeValues,
  type BillingStatus,
  type PlanCode,
} from '@crv/contracts/tenancy';

const planLabels = {
  BASIC: 'Basic',
  PRO: 'Pro',
  ENTERPRISE: 'Enterprise',
} satisfies Record<PlanCode, string>;

const billingStatusLabels = {
  trial: 'Trial',
  active: 'Active',
  past_due: 'Past due',
  canceled: 'Canceled',
} satisfies Record<BillingStatus, string>;

const knownPlanCodes = new Set<string>(planCodeValues);
const knownBillingStatuses = new Set<string>(billingStatusValues);

function isKnownPlanCode(value: string): value is PlanCode {
  return knownPlanCodes.has(value);
}

function isKnownBillingStatus(value: string): value is BillingStatus {
  return knownBillingStatuses.has(value);
}

export function formatPlanLabel(planCode: string | null | undefined): string {
  const normalized = planCode?.trim() ?? '';
  if (!normalized || !isKnownPlanCode(normalized)) {
    return 'Unknown';
  }

  return planLabels[normalized];
}

export function formatBillingStatusLabel(
  billingStatus: string | null | undefined,
): string {
  const normalized = billingStatus?.trim() ?? '';
  if (!normalized || !isKnownBillingStatus(normalized)) {
    return 'Unknown';
  }

  return billingStatusLabels[normalized];
}

export function formatPlanBillingLabel(
  source:
    | {
        planCode?: string | null;
        billingStatus?: string | null;
      }
    | null
    | undefined,
): string {
  return `${formatPlanLabel(source?.planCode)} plan - ${formatBillingStatusLabel(source?.billingStatus)} billing`;
}
